import { SkeletonItem } from '@capsicum/common-web';

import * as S from './styled';

/**
 * The asset card skeleton component used by NCWSendAssetSelector
 */
export const NCWSendAssetCardSkeleton = () => (
	<S.Card>
		<S.CardStart>
			{/* TODO: Will update the hard-coded numbers when Maria finishes her Figma design */}
			<SkeletonItem borderRadius={9999} height={48} width={48} />
		</S.CardStart>
		<S.CardContent>
			<S.CardRow>
				<SkeletonItem borderRadius={0} height={18} width={100} />
			</S.CardRow>
			<S.CardRow>
				<SkeletonItem borderRadius={0} height={12} width={200} />
			</S.CardRow>
		</S.CardContent>
	</S.Card>
);
